<footer id="app-mobile-footer">
    <a id="mobile-footer-home-link" [routerLink]="appRoutes.routes().DASHBOARD" class="mobile-footer-item">
        <i class="fa-light fa-house"></i>
        <label for="mobile-footer-home-link" id="mobile-footer-home-link-label">
            {{ 'home' | translate | uppercase }}
        </label>
    </a>
    <button
        pButton
        (click)="cartOrdersMenu.toggle($event)"
        class="nav-btn mobile-footer-item"
        id="mobile-footer-orders-btn"
        type="button">
        <i
            pBadge
            [value]="cartOrdersNumber"
            [class.hide-badge]="cartOrdersNumber === '0'"
            severity="danger"
            class="fa-light fa-cart-shopping"></i>
        <label for="mobile-footer-orders-btn" id="mobile-footer-orders-btn-label">
            {{ 'appNav.myOrders' | translate | uppercase }}
        </label>
    </button>
    <button
        pButton
        type="button"
        class="nav-btn mobile-footer-item"
        id="mobile-footer-menu-btn"
        (click)="toggleSidebar()">
        <i class="fa-light fa-bars"></i>
        <label for="mobile-footer-menu-btn" id="mobile-footer-menu-btn-label">
            {{ 'menu' | translate | uppercase }}
        </label>
    </button>
</footer>

<p-overlayPanel
    #cartOrdersMenu
    styleClass="fixed-position mobile-nav-overlay"
    [ariaLabel]="'toolbar.cartOrdersMenu.ariaLabel' | translate"
    [focusOnShow]="true">
    <app-menu-cart-orders></app-menu-cart-orders>
</p-overlayPanel>

<p-sidebar
    id="app-mobile-sidebar"
    position="right"
    [showCloseIcon]="false"
    [(visible)]="isSidebarVisible"
    [modal]="true"
    [dismissible]="true"
    [blockScroll]="true"
    [closeOnEscape]="true">
    <div id="sidebar-content" trapFocus>
        <app-navigation [isSidebarCollapsed]="false" [isOnMobile]="true"></app-navigation>
    </div>
</p-sidebar>
